<template>
  <v-card>
    <v-container grid-list-md pa-0>
      <v-layout row>
        <v-flex grow py-0>
          <v-card-title class="headline">Copy the url to share</v-card-title>
        </v-flex>
        <v-flex shrink py-0>
          <v-btn icon @click="$emit('closing')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <div class="link-box">
            <a :href="urlLink" target="_blank">{{ urlLink }}</a>
          </div>
        </v-flex>
      </v-layout>
      <v-btn depressed class="modal-btn" @click="$emit('closing')">Done!</v-btn>
    </v-container>
  </v-card>
</template>

<script>

export default {
data() {
    return {
      previewComponents: this.$store.state.chosenComponents,
      brand: this.$store.state.chosenBrand
    };
  },
computed: {
  urlLink () {
    return "https://dealerdraft.gosokal.com/preview?" + this.brandParam() + '&comps=' + this.compsParam()
  }
},
methods: {
  brandParam () {
    return 'brand=' + this.brand.toLowerCase();
  },
  compsParam() {
    let idArray = [];
    this.previewComponents.map(function(c){
      idArray.push(c.id);
    })
    return idArray.join('-');
  }
}
}
</script>

<style scoped>
.v-dialog .v-card {
  padding: 15px 30px;
  font-size: 15px;
}
.v-dialog .v-card .v-card__title {
  padding-left: 0px;
}
.modal-btn {
  margin-left: 0px;
  background: #006aff !important;
  color: #fff;
  border: 2px solid #006aff !important;
  font-size: 16px;
  font-weight: 500;
}
.modal-btn:hover {
  background: #fff !important;
  color: #006aff;
}
.package-note .material-icons {
  color: #006aff;
  font-size: 20px;
  position: relative;
  top: 4px;
}
.link-box {
  margin: 15px auto 30px;
  padding: 15px;
  background: #f5f5f5;
  border: 1px solid #eee;
  border-radius: 8px;
}
.link-box a {
  color: #006aff !important;
}
</style>

<style>
.v-dialog__content {
  z-index: 9999 !important;
}
</style>